import type { GridFilterOperator } from '@mui/x-data-grid-pro';
import type { GroupedGridColDef } from './gridColumnTypes';
import type { AddressInfo } from '../../../types';

const ADDRESS_COMPONENTS: { field: keyof AddressInfo; headerName: string }[] = [
  { field: 'streetAddress', headerName: 'Street Address' },
  { field: 'city', headerName: 'City' },
  { field: 'state', headerName: 'State' },
  { field: 'zip', headerName: 'Zip' },
  { field: 'country', headerName: 'Country' }
];

// Header labels, reused by inventoryUtils TABS_LIST so the column-category tabs stay in sync.
export const ADDRESS_COLUMN_HEADERS: string[] = ADDRESS_COMPONENTS.map(({ headerName }) => headerName);

// Address-component columns shared by the Inventory/Orders/Projects/Cases grids.
// Off by default (defaultHidden); read the nested addressInfo object. filterOperators
// are passed in (callers use standardOperators) to keep this module dependency-free.
export const addressComponentColumns = (
  filterOperators: GridFilterOperator[],
  columnGroup?: string
): GroupedGridColDef[] =>
  ADDRESS_COMPONENTS.map(({ field, headerName }) => ({
    field: `addressInfo.${field}`,
    headerName,
    sortable: true,
    width: 180,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    valueGetter: (_value, row) => row?.addressInfo?.[field],
    filterOperators,
    description: 'Drag to move column',
    defaultHidden: true,
    ...(columnGroup ? { columnGroup } : {})
  }));
